import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Ttm} from '../../../classes/ttm';
import {Project} from '../../../classes/project';
import {TtmType} from '../../../classes/ttmtype';
import {TtmStatus} from '../../../classes/ttmstatus';
import {CodaltComponent} from '../../codalt/codalt.component';
import {ProjectService} from '../../../services/project.service';
import {Customer} from '../../../classes/customer';
import {Drawing} from '../../../classes/drawing';
import {Utils} from '../../../utils.class';
import {DrawingService} from '../../../services/drawing.service';
import {CustomerService} from '../../../services/customer.service';

@Component({
    selector: 'app-import-drawing-dialog',
    templateUrl: './import-drawing-dialog.component.html',
    styleUrl: './import-drawing-dialog.component.scss'
})
export class ImportDrawingDialogComponent extends CodaltComponent implements OnInit {

    form = new FormGroup({
        customer_id: new FormControl(null, Validators.required),
        project_id: new FormControl(null, Validators.required),
        name: new FormControl(null, Validators.required),
        filename: new FormControl(null, Validators.required)
    });
    projects: Project[] = [];
    customers: Customer[] = [];
    drawings: Drawing[] = [];
    @ViewChild('uploadInput') uploadInput: HTMLInputElement;

    constructor(public dialogRef: MatDialogRef<ImportDrawingDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: {
                    ttm: Ttm,
                    project: Project,
                    ttmTypes: TtmType[],
                    ttmStatuses: TtmStatus[]
                },
                private projectService: ProjectService,
                private drawingService: DrawingService,
                private customerService: CustomerService) {
        super();
    }

    ngOnInit() {
        this.subscriptions.add(this.customerService.list().subscribe(response => {
            this.customers = response.data;
        }));
        this.subscriptions.add(this.projectService.list().subscribe(response => {
            this.projects = response.data;
        }));

        this.subscriptions.add(this.drawingService.list().subscribe(response => {
            this.drawings = response.data;
        }));
    }

    uploadDrawing(event) {
        const file = event.srcElement.files[0];
        console.log(file, event, this.uploadInput);
        this.uploadInput.value = '';
        this.subscriptions.add(this.drawingService.upload(file).subscribe(result => {
            console.log(result);
            setTimeout(() => {
                this.form.controls.filename.setValue(result.data.filename);
                console.log(file.name, file.name.split(/(\\|\/)/g).pop());
                this.form.controls.name.setValue(file.name.split(/(\\|\/)/g).pop());
            });
        }));
    }

    save() {
        Utils.triggerValidationP(this.form).then(() => {
            this.drawingService.save(this.form.value as Drawing).subscribe(result => {
                this.dialogRef.close(result.data);
            });
        }, () => {
        });
    }

    onClose(): void {
        this.dialogRef.close();
    }
}

